import {
  ArrowLeftRight,
  BarChart3,
  Boxes,
  Building2,
  Clock,
  Container,
  HandCoins,
  LogIn,
  LogOut,
  Package,
  PackagePlus,
  ReceiptText,
  Route,
  Ruler,
  Scale,
  Settings2,
  ShieldCheck,
  ShoppingBasket,
  ShoppingCart,
  Tags,
  TrendingUp,
  Truck,
  Users,
  UsersRound,
  Wallet,
  Warehouse,
} from 'lucide-react'

// Menú lateral de administración. Solo reordena pantallas que ya existen:
// las rutas (URLs) no cambian. Un grupo se abre solo al navegar a una de
// sus opciones. Los permisos los siguen resolviendo las pantallas y
// Supabase, igual que antes; el rol POS Venta conserva su menú propio.
export const MENU_ADMIN = [
  {
    id: 'contabilidad',
    titulo: 'Contabilidad',
    icono: Wallet,
    secciones: [
      {
        items: [
          {
            to: '/gastos',
            etiqueta: 'Gastos',
            icono: ReceiptText,
          },
          {
            to: '/ingresos',
            etiqueta: 'Ingresos',
            icono: TrendingUp,
          },
          {
            to: '/contabilidad/cuentas-por-pagar',
            etiqueta: 'Cuentas por Pagar',
            icono: HandCoins,
          },
        ],
      },
    ],
  },
  {
    id: 'logistica',
    titulo: 'Logística',
    icono: Route,
    secciones: [
      {
        titulo: 'Abastecimiento',
        items: [
          {
            to: '/compras/nueva',
            etiqueta: 'Nueva compra',
            icono: Scale,
          },
          {
            to: '/compras',
            etiqueta: 'Historial',
            icono: ShoppingBasket,
            exacto: true,
          },
        ],
      },
      {
        titulo: 'Inventario',
        items: [
          {
            to: '/bodega/saldos',
            etiqueta: 'Saldos',
            icono: Boxes,
          },
          {
            to: '/bodega/saldos-iniciales',
            etiqueta: 'Saldos iniciales',
            icono: PackagePlus,
          },
          {
            to: '/bodega/entrada',
            etiqueta: 'Nueva entrada',
            icono: LogIn,
          },
          {
            to: '/bodega/salida',
            etiqueta: 'Nueva salida',
            icono: LogOut,
          },
          {
            to: '/bodega/movimientos',
            etiqueta: 'Movimientos',
            icono: ArrowLeftRight,
          },
        ],
      },
      {
        titulo: 'Transferencias',
        items: [
          {
            to: '/bodega/transferencia',
            etiqueta: 'Transferencias',
            icono: Truck,
          },
        ],
      },
    ],
  },
  {
    id: 'ventas',
    titulo: 'Ventas',
    icono: ShoppingCart,
    secciones: [
      {
        items: [
          {
            to: '/pos/nueva-venta',
            etiqueta: 'Nueva venta',
            icono: ShoppingCart,
          },
          {
            to: '/pos/ventas',
            etiqueta: 'Ventas',
            icono: ReceiptText,
          },
          {
            to: '/pos/pagos-pendientes',
            etiqueta: 'Pagos pendientes',
            icono: Clock,
          },
          {
            to: '/pos/analitica',
            etiqueta: 'Analítica POS',
            icono: BarChart3,
          },
        ],
      },
    ],
  },
  {
    id: 'bodegas',
    titulo: 'Bodegas',
    icono: Warehouse,
    to: '/mantenedores/bodegas',
  },
  {
    id: 'mantenedores',
    titulo: 'Mantenedores',
    icono: Settings2,
    secciones: [
      {
        items: [
          {
            to: '/proveedores',
            etiqueta: 'Proveedores',
            icono: Truck,
          },
          {
            to: '/mantenedores/clientes',
            etiqueta: 'Clientes',
            icono: UsersRound,
          },
          {
            to: '/mantenedores/productos',
            etiqueta: 'Productos',
            icono: Package,
          },
          {
            to: '/mantenedores/categorias-producto',
            etiqueta: 'Categorías productos',
            icono: Tags,
          },
          {
            to: '/mantenedores/unidades-medida',
            etiqueta: 'Unidades de medida',
            icono: Ruler,
          },
          {
            to: '/mantenedores/cajas-rejillas',
            etiqueta: 'Cajas/Rejillas',
            icono: Container,
          },
          {
            to: '/mantenedores/categorias',
            etiqueta: 'Categorías gastos',
            icono: Tags,
          },
        ],
      },
    ],
  },
  {
    id: 'administracion',
    titulo: 'Administración',
    icono: ShieldCheck,
    secciones: [
      {
        items: [
          {
            to: '/mantenedores/empresas',
            etiqueta: 'Empresas',
            icono: Building2,
          },
          {
            to: '/mantenedores/usuarios',
            etiqueta: 'Usuarios',
            icono: Users,
          },
        ],
      },
    ],
  },
]

export function rutaCoincide(pathname, to) {
  return pathname === to || pathname.startsWith(`${to}/`)
}

// Grupos que contienen la ruta actual (para mantenerlos abiertos).
export function gruposDeRuta(pathname) {
  return MENU_ADMIN.filter((grupo) =>
    (grupo.secciones || []).some((seccion) =>
      seccion.items.some((item) => rutaCoincide(pathname, item.to))
    )
  ).map((grupo) => grupo.id)
}

